import { Component, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Observable, merge } from 'rxjs';
import { tap, filter, map, switchMap } from 'rxjs/operators';
import { debugToConsole } from './shared/dev/debug-operator';

import { Direction } from './shared/layout/header/sticky-header.directive';

// Third Party
import { TranslateModule, TranslateService, TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isSideBarOpen: boolean = true;
  onSibarOpenEvent = (args: boolean) => {
    this.isSideBarOpen = args;
  }

  isTopMost: boolean = false;
  directionHandler$ = (direction$: Observable<Direction>) =>
    direction$.pipe(
      //debugToConsole("direction$:"),
      tap((event) => {
        this.isTopMost = event === Direction.Down;
      }),
    )

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translateService: TranslateService
  ) {
    //Note; translate Service required minimum settings! 
    translateService.addLangs(['en'/*, 'ru'*/]);
    translateService.setDefaultLang('en');

    // this language will be used as a fallback when a translation isn't found in the current language
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translateService.use('en');//http://localhost:4200/assets/i18n/en.json

    //translate.get('HELLO', { value: 'world' }).subscribe((res: string) => {
    //  console.log(res);
    //  //=> 'hello world'
    //});

    // Change page title
    const onNavigationEnd = this.router.events.pipe(filter(event => event instanceof NavigationEnd));
    merge(this.translateService.onLangChange, onNavigationEnd)
      .pipe(
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }

          //console.log("route.outlet - ", route.outlet);
          //console.log("route.url - ", route.toString());

          return route;
        }),
        //filter(route => route.outlet === 'primary'),
        switchMap(route => route.data),
      )
      .subscribe(event => {
        //console.log("NavigationEnd: event - ", event);

        const title = event.title;
        if (title) {
          this.titleService.setTitle(this.translateService.instant(title));
        }
      });

  }
}
